// Shell header (logo + selector slot) shared strings — EN + TR.
//
// Reibul-style split shell: the sidebar owns a logo box + a role-specific
// selector box. Admin uses the OrgContextSwitcher; seller uses the minimal
// StoreSelector below (connected stores / empty "add store" state).

import type { LocalizedDict } from '../index'

type ShellHeaderStrings = {
  storeSelector: {
    label: string
    activeStore: string
    noStores: string
    addStore: string
    manageStores: string
    searchStores: string
    noSearchResults: string
  }
}

export const shellHeaderI18n: LocalizedDict<ShellHeaderStrings> = {
  en: {
    storeSelector: {
      label: 'Stores',
      activeStore: 'Active store',
      noStores: 'No connected store',
      addStore: 'Add store',
      manageStores: 'Manage stores',
      searchStores: 'Search stores…',
      noSearchResults: 'No matching store',
    },
  },
  tr: {
    storeSelector: {
      label: 'Mağazalar',
      activeStore: 'Aktif mağaza',
      noStores: 'Bağlı mağaza yok',
      addStore: 'Mağaza ekle',
      manageStores: 'Mağazaları yönet',
      searchStores: 'Mağaza ara…',
      noSearchResults: 'Eşleşen mağaza yok',
    },
  },
}
